<template>
  <div class="bot-selector" @click="onShow">
    <div>
      添加机器人
    </div>
    <a-modal
        title="选择一个机器人"
        :visible="visible"
        :confirmLoading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
        :closable="false"
        :centered="true"
        :destroyOnClose="true"
        cancelText="取消"
        okText="完成"
        width="1024px"
        style="text-align: center; height: 100px"
    >
      <a-select show-search :filter-option="false" @search="handleSearch" :notFoundContent="allBotList.length ? '请输入搜索词' : '机器人列表加载中'" optionLabelProp="nickname" @select="onSelect" @deselect="onDeselect" style="width: 400px; margin-left: auto; margin-right: auto" mode="multiple" :autoFocus="true">
        <a-select-option :key="bot.username" :nickname="bot.nickname" v-for="bot in filterList">
          <div class="avatar-36-con">
            <img class="avatar" :src="bot.avatar_url"/>
            <div class="nickname">{{bot.nickname + (bot.username ? '（' + bot.username + '）' : '')}}</div>
          </div>
        </a-select-option>
      </a-select>
      <a-checkbox v-model="showLess" style="margin-left: 50px;"></a-checkbox>
      只显示前100个搜索结果(减少卡顿)
    </a-modal>
  </div>
</template>

<script>
import ASelect from 'ant-design-vue/es/select/index'
const axios = require('axios')
export default {
  name: 'BotSelect',
  components: {ASelect},
  props: ['allBotList', 'dataIndex'],   // dataIndex 是 client_id
  data () {
    return {
      batchAddBotUrlPostFix: 'UBot/batch_add_bot',
      selectedBotList: [],
      visible: false,
      confirmLoading: false,
      filterList: [],
      value: '',
      showLess: true
    }
  },
  computed: {
    batchAddBotUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.batchAddBotUrlPostFix
    },
  },
  methods: {
    handleSearch (value) {
      if (!value) {
        this.filterList = []
      } else if (!this.showLess) {
        this.filterList = this.allBotList.filter(item => {
          return item.nickname && item.nickname.indexOf(value) !== -1
        })
      } else {
        this.filterList = this.allBotList.filter(item => {
          return item.nickname && item.nickname.indexOf(value) !== -1
        }).slice(0, 100)
      }
    },
    onShow () {
      this.visible = true
    },
    handleOk () {
      // console.log('handleOk')
      this.onFinish()
    },
    handleCancel () {
      // console.log('handleCancel')
      this.onCancel()
    },
    filterOption (input, option) {
      // console.log('filterOption', input, option)
      var res = false
      var nickname = option.data.attrs.nickname
      if (nickname && nickname.indexOf(input) !== -1) {
        res = true
      }
      return res
    },
    onSelect (value, option) {
      // console.log('onSelect', value, option)
      const bot = this.allBotList.find(item => item.username === value)
      if (bot) {
        this.selectedBotList.push(bot)
      }
    },
    onDeselect (value, option) {
      // console.log('onDeselect', value, option)
      const bot = this.selectedBotList.find(item => item.username === value)
      if (bot) {
        this.selectedBotList.pop(bot)
      }
    },
    onFinish () {
      // console.log('onFinish', this.selectedBotList)
      this.batchAddBot(this.dataIndex, this.selectedBotList)
      // console.log('$emit', this.selectedBotList)
    },
    batchAddBot (clientId, botSelectedList) {
      this.confirmLoading = true
      var botUsernameList = []
      botSelectedList.forEach((item) => {
        botUsernameList.push(item.username)
      })
      axios.post(this.batchAddBotUrl, {
        bot_username_list: botUsernameList,
        client_id: clientId,
        token: sessionStorage.token
      })
          .then((data) => {
            if (data.data.err_code === 0) {
              // console.log('添加 Bot 成功')
              this.visible = false
              this.confirmLoading = false
              this.$emit('on-seleted', this.dataIndex, this.selectedBotList)
              this.selectedBotList = []
            } else if (data.data.err_code === 50002) {
              console.log('token 不对，跳转登录')
              this.$router.push('/')
            }
          })
    },
    onCancel () {
      // console.log('onCancel', this.selectedBotList)
      this.$emit('on-cancel')
      this.visible = false
      this.confirmLoading = false
      // this.selectedBotList = []
    }
  }
}
</script>

<style scoped>

</style>
